export var applicationLoaderActionTypes = {
    SHOW_APPLICATION_LOADER: 'SHOW_APPLICATION_LOADER',
    HIDE_APPLICATION_LOADER: 'HIDE_APPLICATION_LOADER',
};
